<img id="{{ id() }}ProfilePicture"
    [alt]="alt()"
    class="profile-pic-display"
    [height]="size()"
    onerror="this.src='/assets/images/defaults/default-profile-picture.png'"
    [src]="viewState?.profilePictureUri ? $safeNavigationMigration(viewState?.profilePictureUri) + '?cache=' + cacheBuster : '/assets/images/defaults/default-profile-picture.png'"
    [width]="size()" />
